<template>
    <div>
        <h1>Explore Data</h1>
        <div class="sightings">
            <!-- <div class="sightings-project">
                <label for="project">Project/Species:</label>
                <input
                    v-model="project"
                    type="text"
                    id="project"
                    name="project"
                    value
                    readonly
                />
            </div> -->
            <div>
                <label for="project-group">Project Group</label>
                <select
                    id="project-group"
                    v-model="projectGroup"
                    @change="projectGroupChange($event.target.value)"
                >
                    <option value="0" disabled>Select Project Group</option>
                    <option
                        v-for="option in projectGroups"
                        v-bind:key="option.key"
                        :value="option.id"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <div>
                <label for="project">Project</label>
                <select
                    id="project"
                    v-model="project"
                    :disabled="projectsDisabled"
                    @change="
                        projectChangeField($event.target.selectedOptions[0])
                    "
                >
                    <option keyword="" value="" disabled>Select Project</option>
                    <option
                        v-for="option in projects"
                        v-bind:key="option.key"
                        :value="option.species"
                        v-bind:keyword="option.keyword"
                    >
                        {{ option.name }}
                    </option>
                </select>
            </div>
            <template v-if="!isLoading">
                <a
                    class="sightings-sighting"
                    v-for="sighting in sightings"
                    :key="sighting.id"
                    :sighting="sighting"
                    :href="sighting.sightingUrl"
                >
                    <div>
                        Sighting Date: {{ sighting.sightingDate }}<br />
                        Project/Species: {{ sighting.species }}<br />
                        Project/Group: {{ sighting.projectGroupName }}<br />
                        Project/Report: {{ sighting.projectReportName }}<br />
                        Latitude/Longitude: {{ sighting.latitude }},
                        {{ sighting.longitude }}<br />
                        Location: {{ sighting.nearest }},
                        {{ sighting.nearestst }}
                        <br v-if="sighting.number > 0" />
                        <span v-if="sighting.number > 0">
                            Number: {{ sighting.number }}
                        </span>
                        <br
                            v-if="
                                sighting.duration &&
                                    sighting.duration != '00:00:00'
                            "
                        />
                        <span
                            v-if="
                                sighting.duration &&
                                    sighting.duration != '00:00:00'
                            "
                        >
                            Duration (Daylight): {{ sighting.duration }}
                        </span>
                        <br
                            v-if="
                                sighting.numberDuration &&
                                    sighting.numberDuration != '00:00:00'
                            "
                        />
                        <span
                            v-if="
                                sighting.numberDuration &&
                                    sighting.numberDuration != '00:00:00'
                            "
                        >
                            Duration (Number Sighted):
                            {{ sighting.numberDuration }}
                        </span>
                    </div>
                    <div>
                        <img
                            v-if="sighting.imageUrl"
                            :src="sighting.imageUrl"
                            alt=""
                        />
                    </div>
                </a>
            </template>
            <p v-else>
                Loading sightings
            </p>
        </div>
        <div v-if="showMore">
            <button name="buttonMore" @click="loadMore()">More</button>
        </div>
    </div>
</template>

<script>
import axios from 'axios'

const FIELD_DISABLED = 0,
    FIELD_ENABLED = 1

export default {
    data() {
        return {
            isLoading: false,
            sightings: [],
            customerId: '',
            email: '',
            page: 1,
            limit: 20,
            more: false,
            project: 'Practice Report (Any Species)',
            timestamp: '',

            projectGroup: '',
            projectGroups: [],
            projects: [],
            projectFieldState: FIELD_DISABLED,

            projectKeywordParam: ''
            // pageLoaded: false
        }
    },
    computed: {
        showMore() {
            return this.more
        },
        projectsEnabled() {
            return this.projectFieldState === FIELD_ENABLED
        },
        projectsDisabled() {
            return this.projectFieldState === FIELD_DISABLED
        }
    },
    methods: {
        reset() {
            // reset form to initial state
            this.projectFieldState = FIELD_DISABLED
        },
        projectGroupChange(projectGroupId) {
            console.log(projectGroupId)
            this.projectFieldState = FIELD_DISABLED
            axios
                .get(
                    process.env.VUE_APP_API_DOMAIN +
                        '/projects/' +
                        projectGroupId
                )
                .then(({ data }) => {
                    this.projects = data.projects
                    if (this.projects.length > 1) {
                        this.project = ''
                        this.projectFieldState = FIELD_ENABLED
                    } else {
                        this.$router.push(
                            '/sightings/' + data.projects[0].keyword
                        )
                        this.project = data.projects[0].species
                        this.projectChange(data.projects[0].keyword)
                        this.projectFieldState = FIELD_DISABLED
                    }
                    console.log(this.projectsDisabled)
                })
        },
        projectChangeField(fieldOption) {
            this.$router.push(
                '/sightings/' + fieldOption.attributes['keyword'].value
            )
            this.projectChange()
        },
        projectChange() {
            this.page = 1
            this.limit = 20

            this.isLoading = true
            axios
                .post(process.env.VUE_APP_API_DOMAIN + '/sightings/all', {
                    page: this.page,
                    limit: this.limit,
                    project: this.project
                })
                .then(({ data }) => {
                    this.sightings = data.sightings
                    this.timestamp = data.timestamp
                    this.isLoading = false

                    let offsetPage = this.page - 1
                    let sightingsLoaded = offsetPage * this.limit + this.limit
                    if (data.totalSightings > sightingsLoaded) {
                        this.more = true
                        this.page++
                    } else this.more = false
                })
        },
        loadMore() {
            axios
                .post(process.env.VUE_APP_API_DOMAIN + '/sightings/all', {
                    page: this.page,
                    limit: this.limit,
                    project: this.project,
                    timestamp: this.timestamp
                })
                .then(({ data }) => {
                    this.isLoading = false

                    let sightings = this.sightings
                    data.sightings.forEach(function(sighting) {
                        sightings.push(sighting)
                    })

                    let offsetPage = this.page - 1
                    let sightingsLoaded = offsetPage * this.limit + this.limit
                    if (data.totalSightings > sightingsLoaded) {
                        this.more = true
                        this.page++
                    } else this.more = false
                })
        }
    },
    created() {
        this.projectKeywordParam = this.$route.params.projectKeyword
        console.log(this.projectKeywordParam)

        // Populate group dropdown
        axios
            .get(process.env.VUE_APP_API_DOMAIN + '/projects/groups')
            .then(({ data }) => {
                this.projectGroups = data.projectGroups
            })

        if (!this.projectKeywordParam) this.projectGroup = 0
        else {
            console.log('fetch ID and projects')
            axios
                .get(
                    process.env.VUE_APP_API_DOMAIN +
                        '/projects/keyword/' +
                        this.projectKeywordParam
                )
                .then(({ data }) => {
                    this.projects = data.projects
                    this.projectGroup = data.groupId
                    this.project = data.projectSpecies
                    if (this.projects.length == 0) {
                        this.projectGroup = 0
                    } else {
                        if (this.projects.length > 1) {
                            this.projectFieldState = FIELD_ENABLED
                        } else {
                            this.projectFieldState = FIELD_DISABLED
                        }
                        console.log(this.projectsDisabled)

                        this.isLoading = true

                        axios
                            .post(
                                process.env.VUE_APP_API_DOMAIN +
                                    '/sightings/all',
                                {
                                    page: this.page,
                                    limit: this.limit,
                                    project: data.projectSpecies
                                }
                            )
                            .then(({ data }) => {
                                this.sightings = data.sightings
                                this.timestamp = data.timestamp
                                this.isLoading = false

                                let offsetPage = this.page - 1
                                let sightingsLoaded =
                                    offsetPage * this.limit + this.limit
                                if (data.totalSightings > sightingsLoaded) {
                                    this.more = true
                                    this.page++
                                } else this.more = false
                            })
                    }
                })
        }
    }
}
</script>
